export const useHospitalHandlers = (
  selectedHospitals: string[],
  setSelectedHospitals: (hospitals: string[]) => void,
  availableHospitals: Array<{ name: string }>
) => {
  const handleHospitalChange = (hospitalName: string) => {
    setSelectedHospitals(
      selectedHospitals.includes(hospitalName)
        ? selectedHospitals.filter(name => name !== hospitalName)
        : [...selectedHospitals, hospitalName]
    );
  };

  const handleSelectAll = () => {
    setSelectedHospitals(availableHospitals.map(hospital => hospital.name));
  };

  const handleClear = () => {
    setSelectedHospitals([]);
  };

  return {
    handleHospitalChange,
    handleSelectAll,
    handleClear
  };
}; 